import { benefitCategoryLookupCodes } from 'enrollment/utils/common/constant';
import { PlanYear } from 'theSource/queries';

export const mapCategoriesData = (planYears: PlanYear[]) => {
  let expectedBenefits = benefitCategoryLookupCodes;

  return planYears.flatMap((planYear) => {
    const limitedCategories = planYear.benefit_categories.filter((category) => {
      if (expectedBenefits.includes(category.lookup_code)) {
        const itemIndex = expectedBenefits.indexOf(category.lookup_code);
        expectedBenefits = expectedBenefits.filter((e, i) => i !== itemIndex);
        return true;
      } else {
        return false;
      }
    });

    // categories are usually returned from the API in the order of display_order
    // but we need to ensure that they are sorted by display_order just in case
    return limitedCategories.sort((a, b) => a.display_order - b.display_order);
  });
};
